import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "boxicons/css/boxicons.min.css";
import store from "./store";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
// Bootstrap Icons: el paquete estaba en package.json pero nunca se importaba,
// por lo que los ~328 iconos `bi bi-*` de toda la app salian invisibles
// (botones solo-icono quedaban como un rectangulo vacio diminuto).
import "bootstrap-icons/font/bootstrap-icons.css";
import "./assets/tailwind.css";

// Importar configuración de axios con interceptores
import "./config/axios";

createApp(App).use(router).use(store).mount("#app");
